import {AnyAction, ThunkDispatch} from '@reduxjs/toolkit'
import {useDispatch} from 'react-redux'
import {RootState} from '../../setup/redux'

export const useAppDispatch = () => {
  return useDispatch<ThunkDispatch<RootState, any, AnyAction>>()
}
